module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./HomeConfigView.js"));
	}, "HomeConfig");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=HomeConfig!./src/pages/SystemManage/HomeConfig/HomeConfigView.js
// module id = ./node_modules/bundle-loader/index.js?lazy&name=HomeConfig!./src/pages/SystemManage/HomeConfig/HomeConfigView.js
// module chunks = 43